module.exports = __webpack_public_path__ + "static/media/Rational_Poojas_mr.f6dba7fc.jpg";